"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partyBrands = exports.getTextColor = exports.getImage = exports.getHoverColor = exports.getDarkTextColor = exports.getColor = void 0;
var whiteLabelingUIData = null;
var partyBrands = ["PartyPoker", "PARTYPOKER", "PARTYONCA", "PPDE", "PPIT", "PARTYSE", "PARTYDK"];
exports.partyBrands = partyBrands;
var getColor = function getColor() {
  if (!whiteLabelingUIData) {
    whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
  }
  if (whiteLabelingUIData && whiteLabelingUIData.color) {
    return whiteLabelingUIData.color;
  } else {
    console.log("Default colors are getting used!");
    return "#e8480d";
  }
};
exports.getColor = getColor;
var getTextColor = function getTextColor() {
  if (!whiteLabelingUIData) {
    whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
  }
  if (whiteLabelingUIData && whiteLabelingUIData.textColor) {
    return whiteLabelingUIData.textColor;
  } else {
    return "#ffffff";
  }
};
exports.getTextColor = getTextColor;
var getDarkTextColor = function getDarkTextColor() {
  if (!whiteLabelingUIData) {
    whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
  }
  if (whiteLabelingUIData && whiteLabelingUIData.darkTextColor) {
    return whiteLabelingUIData.darkTextColor;
  } else {
    return "#000000";
  }
};
exports.getDarkTextColor = getDarkTextColor;
var getHoverColor = function getHoverColor() {
  if (!whiteLabelingUIData) {
    whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
  }
  if (whiteLabelingUIData && whiteLabelingUIData.hoverColor) {
    return whiteLabelingUIData.hoverColor;
  } else {
    return "rgba(232, 73, 12, .2)";
  }
};

// export const getImage = (path, fileType) => {
//     if (localStorage.getItem("loggedInType") === "Brand" && localStorage.getItem("brandLogin") && JSON.parse(localStorage.getItem("brandLogin")).brand){
//         return path + JSON.parse(localStorage.getItem("brandLogin")).brand.toLowerCase() + fileType;
//     } else if (localStorage.getItem("loggedInType")){
//         return path + localStorage.getItem("loggedInType") + fileType;
//     } else {
//         return path + "PartyPoker" + fileType;
//     }
// }
exports.getHoverColor = getHoverColor;
var getImage = function getImage(path, fileType) {
  if (path === "/images/pokerQuiz/") {
    if (partyBrands.includes(localStorage.getItem("loggedInType"))) {
      return path + "PartyPoker" + fileType;
    } else {
      return path + "NonPartyLables" + fileType;
    }
  } else if (localStorage.getItem("loggedInType") === "Brand" && localStorage.getItem("brandLogin") && JSON.parse(localStorage.getItem("brandLogin")).brand) {
    return path + JSON.parse(localStorage.getItem("brandLogin")).brand.toLowerCase() + fileType;
  } else if (localStorage.getItem('loggedInType') == null || partyBrands.includes(localStorage.getItem("loggedInType"))) {
    return path + 'PartyPoker' + fileType;
  } else {
    return path + localStorage.getItem("loggedInType") + fileType;
  }
};
exports.getImage = getImage;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/common/ThemeService.js
 ** module id = 89
 ** module chunks = 0
 **/